import React, { useContext, useState } from 'react';
import { 
    Dialog, DialogTitle, DialogContent, DialogActions, 
    Button, TextField, Grid, MenuItem, CircularProgress, Alert
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import 'moment/locale/es';


import UserContext from '../../navigation/context/userContext';
import { CreatePerson } from '../../controllers/company/crm/CustomersController';

const DOCUMENT_TYPES = [
    { value: 'V', label: 'Venezolano (V)' },
    { value: 'E', label: 'Extranjero (E)' },
    { value: 'J', label: 'Jurídico (J)' },
    { value: 'P', label: 'Pasaporte (P)' }
];

export default function CreateEntityModal({ 
    open, 
    onClose, 
    onSuccess, 
    //merchantCountry = 'VE' 
}) {
    const {userData,setUserData} = useContext(UserContext);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const [form, setForm] = useState({
        name: '',
        last_name: '',
        document_type: 'V',
        document_number: '',
        phone: '',
        email: '',
        birth_date: null // <--- Nuevo campo (nulo por defecto porque es opcional)
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleDateChange = (newValue) => {
        setForm(prev => ({ ...prev, birth_date: newValue }));
    };

    const handleSubmit = async () => {
        setErrorMsg('');

        if (!form.name || !form.phone) {
            setErrorMsg('El nombre y el teléfono son obligatorios (*)');
            return;
        }

        if (userData.entity === 1 && !form.document_number) {
            setErrorMsg('El número de documento es obligatorio para comercios en Venezuela (*)');
            return;
        }

        setLoading(true);

        const payload = { 
            ...form,
            birthdate: form.birth_date ? form.birth_date.format('YYYY-MM-DD') : null, // Lo enviamos pegado
            country_id: userData.entity.country_id, // Aquí podrías enviar el ID del país si lo tienes, o dejar que el backend use el 1 por defecto
            create_user: 1
        };

        const response = await CreatePerson(payload);
        
        setLoading(false);

        if (response.success) {
            onSuccess(response.data);
            setForm({ 
                name: '', last_name: '', document_type: 'V', 
                document_number: '', phone: '', email: '', birth_date: null 
            });
        } else {
            setErrorMsg(response.message);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ fontWeight: 'bold' }}>Nuevo Cliente</DialogTitle>
            
            <DialogContent dividers>
                {/* Envolvemos el Grid con el proveedor de fechas */}
                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es">
                    <Grid container spacing={2} pt={1}>
                        
                        {errorMsg && (
                            <Grid item xs={12}>
                                <Alert severity="error">{errorMsg}</Alert>
                            </Grid>
                        )}

                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Nombre *"
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                                autoFocus
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Apellido"
                                name="last_name"
                                value={form.last_name}
                                onChange={handleChange}
                            />
                        </Grid>

                        {userData.entity.country_id === 1 && (
                            <>
                                <Grid item xs={4} sm={3}>
                                    <TextField
                                        select
                                        fullWidth
                                        label="Tipo"
                                        name="document_type"
                                        value={form.document_type}
                                        onChange={handleChange}
                                    >
                                        {DOCUMENT_TYPES.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.value}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={8} sm={9}>
                                    <TextField
                                        fullWidth
                                        label="Número de Documento *"
                                        name="document_number"
                                        value={form.document_number}
                                        onChange={handleChange}
                                        placeholder="Ej: 12345678"
                                    />
                                </Grid>
                            </>
                        )}

                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Teléfono *"
                                name="phone"
                                value={form.phone}
                                onChange={handleChange}
                                placeholder="Ej: 04141234567"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Correo Electrónico"
                                name="email"
                                type="email"
                                value={form.email}
                                onChange={handleChange}
                                placeholder="ejemplo@correo.com"
                            />
                        </Grid>

                        {/* NUEVO CAMPO: Fecha de Nacimiento */}
                        <Grid item xs={12} sm={6}>
                            <DatePicker
                                label="Fecha de Nacimiento (Opcional)"
                                value={form.birth_date}
                                onChange={handleDateChange}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                                disableFuture // No permitimos fechas en el futuro
                            />
                        </Grid>

                    </Grid>
                </LocalizationProvider>
            </DialogContent>

            <DialogActions sx={{ p: 2 }}>
                <Button onClick={onClose} color="inherit" disabled={loading}>
                    Cancelar
                </Button>
                <Button 
                    onClick={handleSubmit} 
                    variant="contained" 
                    disabled={loading}
                >
                    {loading ? <CircularProgress size={24} color="inherit" /> : 'Guardar y Seleccionar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}